import React from "react";
import CnvBrowser from "../CnvBrowser/CnvBrowser";

function CnvBrowserEmulateClinical(props) {
  const inpRef = React.useRef(null);

  const config = localStorage.getItem("emulate-clinical-cnv-exome");
  window.resultsConfig = JSON.parse(config) || {};

  function submit() {
    const conf = inpRef.current.value;
    localStorage.setItem("emulate-clinical-cnv-exome", conf);
    window.resultsConfig = JSON.parse(config);
    window.location.reload();
  }

  return (
    <>
      <textarea
        ref={inpRef}
        onKeyDown={(e) => {
          if (e.code === "Enter" && e.ctrlKey) submit();
        }}
        className="tw-w-full"
        type="text-area"
        defaultValue={config}
      />

      <CnvBrowser {...props} />
    </>
  );
}

export default CnvBrowserEmulateClinical;
